const COMPANY = {
  EMAIL: process.env.VUE_APP_COMPANY_EMAIL || 'info@dutton.com',
  PHONE: process.env.VUE_APP_COMPANY_PHONE || '6620 9200',
  ADDRESS: process.env.VUE_APP_COMPANY_ADDRESS || 'San Miguel, 2 Calle 1-25, Petapa 01066',
}

export default COMPANY
